import { NullClickStrategy,
         TableFieldDescription, 
         DataMapper,
         TablePickerDisplayStrategy,
         NumberComponentCreator } from '../../../components/BPMTable/TableMapperCreator';
import * as f from '../../../components/BPMTable/BPMInputs'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator';
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator';
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";

// tableQuery movido al test de DirectTableQueryBuilder

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allInvoicePayments')}

class InvoiceGroupPopUpTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InvoiceGroupPopUpTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries, new NullClickStrategy(), new TablePickerDisplayStrategy())
        tableCreator.setInitialSortField('invoicePaymentId', 'desc')
        tableCreator.addDescriptions ([
            new TableFieldDescription(
                'invoicePaymentId',
                new DataMapper("id"),
                new f.FilterDescription(new f.TextFilter("invoicePaymentId")),
                {label: 'Id'}
            ),
            new TableFieldDescription(
                'invoiceId',
                new DataMapper("invoice.identifier"),
                new f.FilterDescription(new f.TextFilter("invoiceId")),
                {label: 'Invoice Identifier'}
            ),
            new TableFieldDescription(
                'invoiceAccount',
                new DataMapper("invoice.account.identifier"),
                new f.FilterDescription(new f.TextFilter("invoiceAccount")),
                {label: 'Account Identifier'}
            ),
            new TableFieldDescription(
                'invoiceTotalCost',
                new DataMapper("invoice.totalCost"),
                new f.FilterDescription(new f.NullCreator()),
                {
                  label: 'Invoice Total Cost', 
                  componentCreator: new NumberComponentCreator(this.parentProps.currentUserData.currency.symbol),
                  fieldAlign: 'right',
                }
            ),
        ])

        return tableCreator
    }
}
    
tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InvoiceGroupPopUpTableCreator)
    
export default InvoiceGroupPopUpTableCreator
    
